import React from "react";
import { LanguageContext } from "@/data/LanguageProvider";
import MyNavLink from "../MyNavLink";
import style from "./style.less";

const InviteHelpHeader = () => {
  const { langText } = React.useContext(LanguageContext);
  return (
    <div class={style.outline}>
      <div class={style.header_content}>
        <div class={`${style.header_left}`}>
          <MyNavLink to="/invite">
            <div style={{ display: "flex", alignItems: "center" }}>
              <div class={style.back_btn}>
                <span style={{fontWeight:"700", fontSize: "1.1rem"}}>{langText("btn_back")}</span>
              </div>
            </div>
          </MyNavLink>
        </div>
        <div class={`${style.header_center}`}>{langText("profile_btn_4")}</div>
        <div class={style.header_right}>&nbsp;</div>
      </div>
    </div>
  );
};

export default InviteHelpHeader;
